var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.4c3.904-1.71 6.508-2.838 7.81-3.383 3.72-1.556 4.493-1.826 4.997-1.835.11-.002.358.026.519.156.135.111.173.26.19.365.018.105.04.344.023.53-.202 2.13-1.074 7.298-1.517 9.683-.188 1.01-.558 1.348-.916 1.381-.778.072-1.368-.517-2.122-1.014-1.178-.776-1.844-1.26-2.989-2.018-1.322-.877-.465-1.358.289-2.145.197-.206 3.624-3.34 3.69-3.625.009-.036.017-.168-.062-.238-.078-.07-.194-.046-.277-.027-.118.027-2.002 1.278-5.65 3.755-.534.369-1.018.549-1.452.54-.478-.011-1.398-.273-2.082-.496-.839-.274-1.506-.42-1.447-.885.03-.243.362-.49.996-.744Z",
    fill: "#2EA7E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d4416929.svg";
export { ForwardRef as ReactComponent };